import { useRouteError as _useRouteError } from 'react-router';

// ----------------------------------------------------------------------

export function useRouteError() {
  return _useRouteError();
}
